import * as React from 'react';
import Select from '@payscale/design/lib/select';
import { mxStrings } from 'utils/JobCollabStrings';
import './locationPicker.scss';

const className = 'location-picker';

export interface LocationPickerProps {
    locations: JobLocation[];
    value?: number;
    onLocationSelect?: (orgJobId: string) => void;
}

class LocationPicker extends React.Component<LocationPickerProps, {}> {

    constructor(props: LocationPickerProps) {
        super(props);
        this._handleChange = this._handleChange.bind(this);
    }

    render(): React.ReactNode {
        const { locations } = this.props;
        const hasLocations = locations && locations.length > 0;
        const hasEmptyLocation = locations.length === 1 && !locations[0].label;

        if (!hasLocations || hasEmptyLocation) {
            return this._renderLabel(mxStrings.unspecifiedValue);
        }

        if (locations.length > 1) {
            return this._renderSelect();
        } else {
            return this._renderLabel(locations[0].label);
        }
    }

    private _renderSelect(): React.ReactNode {
        const { locations, value } = this.props;

        return <Select
            id="locationPicker"
            className={className}
            options={[
                ...((locations || []).map(j =>
                    ({ text: j.label ? j.label : mxStrings.locationNotSet, value: j.orgJobId })))
            ]}
            onChange={this._handleChange}
            value={value || ''}
        />;
    }

    private _renderLabel(text: string): React.ReactNode {
        return <div className={`${className} label-only`}>
            <span>{text}</span>
        </div>;
    }

    private _handleChange(_: undefined, value: string): void {
        const { onLocationSelect } = this.props;
        if (!value || !onLocationSelect) {
            return;
        }

        onLocationSelect(value);
    }
}

export { LocationPicker };
export default LocationPicker;